import { render } from "./RodapeExterno.vue?vue&type=template&id=02d72d63&scoped=true"
import script from "./RodapeExterno.vue?vue&type=script&lang=js"
export * from "./RodapeExterno.vue?vue&type=script&lang=js"

import "./RodapeExterno.vue?vue&type=style&index=0&id=02d72d63&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d72d63"]])

export default __exports__